import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui/Skeleton.tsx';
import { Card } from '@/components/ui/Card.tsx';
import { SectionColumnHeader } from '@/features/dashboard/bookingChanges/components/primitives';
import BillSectionSkeleton from './BillSectionSkeleton';

const SECTION_ROW_COUNTS = [4, 3];

/** Szkielet ekranu osoby zapisującej — dwie sekcje bez kolumny kwot. */
const ClientBillViewSkeleton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <Card className={cn('overflow-hidden', className)} {...props}>
    <div className="px-7 pt-0.5">
      <SectionColumnHeader />

      <div className="flex flex-col gap-3.5 pb-0.5">
        {SECTION_ROW_COUNTS.map((rowCount, index) => (
          <BillSectionSkeleton key={index} rowCount={rowCount} />
        ))}
      </div>
    </div>

    <div className="mt-[22px] flex items-center justify-between gap-5 border-t border-neutral-100 px-7 pb-6 pt-5">
      <Skeleton className="h-3.5 w-80" />
      <Skeleton className="h-8 w-44 rounded-lg" />
    </div>
  </Card>
);

export default ClientBillViewSkeleton;
